import helpers from '../../util/helpers';

const searchGuests = () => {
  jQuery(document).ready(function($) {
    const page = $('html, body');

    // Guests Autocomplete
    const guestsSearch = $('input.guests-search');
    if (guestsSearch.length) {
      guestsSearch.each(function() {
        const _this = $(this);

        _this.rsdAutocomplete({
          minimumInputLength: -1,
          data: _this.data('feed') ? _this.data('feed') : [],
          layout: 1,
          showListName: false,
        });
      });

      guestsSearch.on('click', function() {
        if (helpers.isMobile()) {
          page.on('scroll mousewheel touchmove', function() {
            page.stop();
          });

          page.animate({scrollTop: $(this).offset().top}, 'slow', function() {
            page.off('scroll mousewheel touchmove');
          });
        }
      });

      guestsSearch.on('input', function() {
        const _this = $(this);

        if (_this.data('cookie-guests') && _this.val().length === 0) {
          helpers.docCookies.setItem(_this.data('cookie-guests'), _this.val(), 1500, '/');
        }
      }).on('input_changed.rsd-ac', function() {
        const _this = $(this);

        if (_this.data('cookie-guests')) {
          helpers.docCookies.setItem(_this.data('cookie-guests'), _this.val(), 1500, '/');
        }
      });
    }
  });
};

export default searchGuests;



// WEBPACK FOOTER //
// ./scripts/routes/modules/searchGuests.js